import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppDispatch, persistor, RootState } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const usePersistReduxStoreAndReloadPage = () => {
  const navigate = useNavigate();
  const persistReduxStoreAndReloadPage = async () => {
    await persistor.flush();
    navigate(window.location.pathname, { replace: true });
    navigate(0);
  };

  return persistReduxStoreAndReloadPage;
};
